/**
 * Enlaces de VENTAS por WhatsApp (fuente única).
 *
 * Antes cada superficie armaba su propio link a mano: el CTA "Crear sucursal" tenía la URL
 * hardcodeada y DUPLICADA literal en el navbar desktop y en el drawer móvil, con un formato
 * (`api.whatsapp.com/send?phone=`) distinto al del resto del panel (`wa.me/`). Aquí queda un
 * solo lugar donde viven el número (vía `EXTERNAL_URLS.SALES_WHATSAPP_PHONE`) y los mensajes
 * prellenados, todos armados con el helper canónico `generateWhatsAppLink`.
 *
 * Los mensajes se exportan además de los links para que los tests puedan assertear el texto
 * exacto sin re-teclearlo (mismo patrón que `SCREENS_UPSELL_WHATSAPP_MESSAGE`).
 */
import { EXTERNAL_URLS } from '@utils/constants';
import { generateWhatsAppLink } from './whatsappCore';

export const SALES_WHATSAPP_MESSAGES = {
  createBranch: 'Hola, quiero crear una nueva sucursal para mi comercio.',
  upgradeGeneric: 'Hola, quiero mejorar mi plan de Plick. ¿Me pueden ayudar?',
  upgradePlan: (planName: string) => `Hola, quiero contratar el plan ${planName} de Plick. ¿Me pueden ayudar?`,
} as const;

// CTA "Crear sucursal" (navbar desktop y drawer móvil).
export const buildCreateBranchSalesLink = (): string =>
  generateWhatsAppLink(EXTERNAL_URLS.SALES_WHATSAPP_PHONE, SALES_WHATSAPP_MESSAGES.createBranch);

// CTA de upgrade de plan. Con `planName` el mensaje llega a ventas ya diciendo QUÉ plan quiere el
// comercio (el CTA de una card de plan); sin él queda el mensaje genérico (el CTA de sección,
// donde el comercio todavía no eligió).
export const buildUpgradeSalesLink = (planName?: string): string =>
  generateWhatsAppLink(
    EXTERNAL_URLS.SALES_WHATSAPP_PHONE,
    planName ? SALES_WHATSAPP_MESSAGES.upgradePlan(planName) : SALES_WHATSAPP_MESSAGES.upgradeGeneric,
  );
